export default __webpack_public_path__ + "static/media/topSearchBackground2.39bade12.jpg";